<template>
    <div :class="$style.root">
        <div class="box-news">
            <div class="box-news-video">
                <div class="title" style="margin-left: 10px">最新视频 <span @click="toRecommend" style="margin-right:30px" class="more">更多</span></div>

                <a-spin :spinning="spinning">
                    <div class="spin-content">
                        <newVideoView :latest-video-list="latestVideoList.length>6?latestVideoList.slice(0,6):latestVideoList" />
                    </div>
                </a-spin>
            </div>
            <div class="box-news-text">
                <div class="title">播放排行榜 <span @click="toRecommend" class="more">更多</span></div>

                <newTextView />
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import newVideoView from './newVideoView.vue';
    import newTextView from './newTextView.vue';

    export default {
        name: 'NewVideoViewdemo',
        components: { newVideoView, newTextView },
        data() {
            return {
                spinning: true,
                delayTime: 500,
            };
        },

        computed: {
            ...mapState('indexView', ['latestVideoList', 'indexVideoLoading']),
            ...mapState(['userInfo']),
        },

        mounted() {
            this.handleLoadLatestVideoList();
        },

        methods: {
            ...mapActions('indexView', ['getLatestVideoLIst']),

            // 加载列表
            handleLoadLatestVideoList() {
                // 打印请求参数
                let queries = {};
                // const _this = this;
                const orgId = this.userInfo.org_id || '';

                queries = {
                    orgId: orgId || '',
                    orderType: '3',
                };
                if (!this.userInfo.user_name) {
                    delete queries.orgId;
                }

                
                this
                    .getLatestVideoLIst(queries)
                    .then(() => {
                        this.spinning = false;
                    })
                    .catch(({ message }) => {
                        if (message) this.$message.error(message);
                        this.spinning = false;
                    });
            },
            changeSpinning() {
                this.spinning = !this.spinning;
            },
            toRecommend() {
                this.$router.push({ name: 'RecommendView' });
            },
        },
    };
</script>

<style lang="less" module>
.root {
  :global {
    .box-news {
      max-width: 1200px;
      // height: 400px;
      margin: auto;
      margin-top: 30px;
      // display: flex;
      justify-content: space-around;
        flex-wrap:wrap;
      .box-news-video {
        flex: 1;
          flex-wrap: wrap;
          justify-content: space-around;
          margin-right: 20px;
        .title {
          width: 100%;
          height: 40px;
          line-height: 40px;
          font-size: 16px;
          color: #435573;
          margin-bottom: 10px;
          /*padding-left: 10px;*/
        }
      }
      .box-news-text {
        width: 280px;
        .title {
          width: 100%;
          height: 40px;
          line-height: 40px;
          font-size: 16px;
          color: #435573;
          margin-bottom: 10px;
          /*padding-left: 10px;*/
        }
      }
        .more{
            float: right;
            font-size: 12px;
            cursor:pointer;
        }

    }

      @media screen and (min-width:1024px) and (max-width:1388px) {
          .box-news{
              justify-content: center;
          }
      }
      @media screen and (max-width:1024px) {
          .box-news{
              justify-content: center;
              .box-news-text {
                  width: 310px;
              }
          }

      }
      img {
          position: relative;
      }

      img:after {
          content: url(../../../assets/LOGO_bg.png);
          display: block;
          position: absolute;
          z-index: 2;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: #fff;
      }
  }
}
</style>
